module.exports = __webpack_public_path__ + "img/Loading_r_27.fd9e0036.png";